(function() {
    'use strict';

    angular
        .module('app.horarios')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/horarios',
                config: {
                    templateUrl: 'app/horarios/horarios.html',
                    controller: 'Horarios',
                    controllerAs: 'vm',
                    title: 'Horarios'
                }
            },
            {
                url: '/editar-horario/:id?',
                config: {
                    templateUrl: 'app/horarios/editarHorario.html',
                    controller: 'EditarHorario',
                    controllerAs: 'vm',
                    title: 'EditarHorario'
                }
            }
        ];
    }
})();
